export default __webpack_public_path__ + "static/media/gallery-articles_01.f5552e84.jpg";